import { getMobileDetect } from "@shared/index";
import { useEffect } from "react";

export const useMobileDetect = () => {
  useEffect(() => {}, []);
  const userAgent =
    typeof navigator === "undefined" ? "SSR" : navigator.userAgent;
  return getMobileDetect(userAgent);
};
